import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const StyledNavigation = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 100000;
  margin-bottom: 30px;
  display: flex;
  padding: 0 2em;
  justify-content: space-between;
  width: 100%;
  button {
    border-radius: 4px;
    background-color: #DBF2EF;
    text-transform: initial;
    border: 0;
    padding: 0;
    color: #1E4C47;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.16px;
    line-height: 33px;
    height: 36px;
    width: 96px;
    :hover {
      background: #bfe3de;
      border: 0;
    }
  }
`;

export const StyledCategoryIndicator = styled.div`
  .indicator {
    display: flex;
  }
  &&& button {
    svg {
      transform: rotate(180deg);
    }
  }
`;

export const StyledNavigationLink = styled(NavLink)`
  border-radius: 4px;
  background-color: #DBF2EF;
  text-transform: initial;
  border: 0;
  padding: 0;
  color: #1E4C47;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.16px;
  line-height: 33px;
  height: 36px;
  width: 96px;
  justify-content: center;
  display: flex;
  text-decoration: none;
  :hover {
    background: #bfe3de;
    border: 0;
  }
`;


export const StyledCategoryToggleButtton = styled.button`
 &&& {
    margin-bottom: 10px;
    width: 171px;
    background: none;
    height: 17.5px;
    color: #FCF1D1;
    font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: -0.4px;
    line-height: 17px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 0;
    text-transform: initial;
    hover {
      background: none;
      border: 0;
    }
  }
`;

export const StyledQuestionIndicator = styled.div`
  background-color: white;
  height: 6px;
  width: 100%;
  opacity: ${props => props.current ? ` 1` : ` .7`};
  border-right: 2px solid black;
  margin-top: .5em;

  &:first-child {
      border-top-left-radius: 7px;
      border-bottom-left-radius: 7px;
  }
  &:last-child {
      border-bottom-right-radius: 7px;
      border-top-right-radius: 7px;
      border: unset;
  }
`;

export const StyledCloseCategoryToggle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: -1em;
`;
